/** @jsx onetext.jsx.element */

import type { OneText } from '../../../global';

// eslint-disable-next-line no-restricted-syntax
import { BrandLogo } from '../components';
// eslint-disable-next-line no-restricted-syntax
import { BrandBackgroundDefault } from '../components/background';
// eslint-disable-next-line no-restricted-syntax
import { defaultBrandConfig, SUPPRESSED_KEYWORDS, SUPPRESSED_QUERY_PARAMS, SUPPRESSED_ROUTES } from '../config';

import type { GetPopupAPIResponse, Milliseconds } from '@onetext/api';
import { POPUP_LAYOUT } from '@onetext/api';

declare let onetext : OneText;

const { clsx } = onetext.jsx;

const {
    Popup,
    Page,
    EmailField,
    PhoneField,
    Button,
    Row,
    Column,
    Terms,
    PopupContainer,
    Teaser,
    Quiz,
    QuizOption
} = onetext.component.consent.popup;

type StandardPopupProps = {
    popup : GetPopupAPIResponse,
};

export const StandardPopup = ({
    popup
} : StandardPopupProps) : JSX.Element | null => {
    return (
        <PopupContainer
            popup={ { ...popup, config: defaultBrandConfig } }
            delay={ 500 as Milliseconds }
            suppressedRoutes={ SUPPRESSED_ROUTES }
            suppressedKeywords={ SUPPRESSED_KEYWORDS }
            suppressedQueryParams={ SUPPRESSED_QUERY_PARAMS }
        >
            <Popup
                layout={ POPUP_LAYOUT.FULLSCREEN }
                background={ <BrandBackgroundDefault /> }
            >
                <Page openKeyboardOnSubmit>
                    <Row className={ 'px-4 mt-12 max-w-xl mx-auto' }>
                        <Column>
                            <div className={ 'mb-[16px]' }>
                                <BrandLogo />
                            </div>
                            <div className={ 'text-center space-y-5 font-medium' }>
                                <h1 className={
                                    clsx(
                                        'text-5xl md:text-6xl',
                                        'leading-[1.1em]',
                                        'text-center font-semibold'

                                    )
                                }>
                                    { 'Get Free Shipping' }
                                </h1>

                                { /* eslint-disable-next-line @stylistic/max-len */ }
                                <p className={ 'text-lg max-w-sm font-semibold mx-auto' }>{ 'Sign up for email and SMS to receive extra 10% off' }</p>

                                { /* eslint-disable-next-line @stylistic/max-len */ }
                                <p className={ 'text-center text-sm font-semibold max-w-sm mx-auto' }>{ 'Select your shopping preference:' }</p>
                                <Quiz propertyName={ 'shopping_preference' }>
                                    <div className={
                                        clsx(
                                            'max-w-[274px] mx-auto',
                                            'flex flex-col',
                                            'items-center',
                                            'gap-2.5'
                                        )
                                    }>
                                        <QuizOption propertyValue={ 'black_tea' }>
                                            <Button>
                                                { 'Black Tea' }
                                            </Button>
                                        </QuizOption>
                                        <QuizOption propertyValue={ 'green_tea' }>
                                            <Button>
                                                { 'Green Tea' }
                                            </Button>
                                        </QuizOption>
                                        <QuizOption propertyValue={ 'herbal_tea' }>
                                            <Button>
                                                { 'Herbal Tea' }
                                            </Button>
                                        </QuizOption>
                                        <QuizOption propertyValue={ 'tea_accessories' }>
                                            <Button>
                                                { 'Tea Accessories' }
                                            </Button>
                                        </QuizOption>
                                    </div>
                                </Quiz>
                            </div>
                        </Column>
                    </Row>
                </Page>

                <Page openKeyboardOnSubmit>
                    <Row className={ 'px-4 mt-12 max-w-xl mx-auto' }>
                        <Column>
                            <div className={ 'mb-[16px]' }>
                                <BrandLogo />
                            </div>
                            <div className={ 'text-center space-y-5 font-medium' }>
                                <h1 className={
                                    clsx(
                                        'text-5xl md:text-6xl',
                                        'leading-[1.1em]',
                                        'text-center font-semibold'

                                    )
                                }>
                                    { 'Unlock 5% Off' }
                                </h1>

                                <p className={ 'text-lg max-w-sm font-semibold mx-auto' }>
                                    { 'Enter your email address to claim your 5% discount.' }
                                </p>

                            </div>
                            <div className={
                                clsx(
                                    'max-w-sm w-full',
                                    'flex',
                                    'flex-col',
                                    'items-center',
                                    'gap-2.5 mt-8'
                                )
                            }>
                                <EmailField
                                    placeholder={ 'Email address' }
                                    autofocus={ true }
                                />
                                <Button>
                                    { 'CLAIM YOUR 5% OFF' }
                                </Button>

                            </div>
                        </Column>
                    </Row>
                </Page>

                <Page openKeyboardOnSubmit>
                    <Row className={ 'px-4 mt-12' }>
                        <Column>
                            <div className={ 'mb-[16px]' }>
                                <BrandLogo />
                            </div>
                            <Column className={ 'space-y-5 text-center mb-8' }>
                                <h1 className={
                                    clsx(
                                        'text-5xl md:text-6xl max-w-xl',
                                        'leading-[1.1em]',
                                        'text-center font-semibold'
                                    )
                                }>
                                    { 'Almost There!' }
                                </h1>
                                <p className={
                                    clsx(
                                        'text-lg max-w-sm font-semibold md:max-w-lg',
                                        'leading-relaxed font-base',
                                        'text-center',
                                        'mb-6'
                                    )
                                }>
                                    { 'Enter your phone number to activate your 10% discount.' }
                                </p>

                                <div className={
                                    clsx(
                                        'max-w-sm w-full',
                                        'flex',
                                        'flex-col',
                                        'items-center',
                                        'gap-2.5'
                                    )
                                }>
                                    <PhoneField
                                        placeholder={ 'Phone number' }
                                        autofocus={ true } />
                                    <Button>
                                        { 'ACTIVATE 10% OFF' } <br />
                                    </Button>
                                </div>
                            </Column>
                            <Terms
                                brandName={ 'Fire Belly Tea' }
                                termsUrl={ 'https://www.firebellytea.com/policies/terms-of-service' }
                                privacyUrl={ 'https://www.firebellytea.com/policies/privacy-policy' }
                            />
                        </Column>
                    </Row>
                </Page>

                <Page openKeyboardOnSubmit>
                    <Row className={ 'px-4 mt-12' }>
                        <Column>
                            <div className={ 'mb-[16px]' }>
                                <BrandLogo />
                            </div>
                            <Column className={ 'space-y-4 text-center mb-8 md:mb-12' }>
                                <h1 className={
                                    clsx(
                                        'text-5xl md:text-6xl',
                                        'max-w-2xl',
                                        'font-base',
                                        'text-center font-semibold'
                                    )
                                }>
                                    { 'Did you get it?' }
                                </h1>
                                <p className={
                                    clsx(
                                        'text-lg max-w-sm font-semibold md:max-w-lg',
                                        'leading-relaxed font-base',
                                        'text-center'
                                    )
                                }>
                                    { 'Check your texts to make sure you are in!' }
                                </p>
                            </Column>
                            <Button className={
                                'max-w-sm w-full'
                            }>
                                { 'Return to Website' }
                            </Button>
                        </Column>
                    </Row>
                </Page>

            </Popup>
            <Teaser customText={ 'UNLOCK FREE SHIPPING' } />
        </PopupContainer>
    );
};
